import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-down-thin",
  "use": "arrow-down-thin-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"arrow-down-thin\"><path d=\"M7.03 13.92H11.03V5L13.04 4.97V13.92H17.03L12.03 18.92Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol